// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Section-Propiedadesmexico {
  width: 84%;
  max-width: 1600px;
  min-height: 500px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: auto;
  flex-wrap: nowrap;
}
.Section-Propiedadesmexico hr {
  background-color: brown;
}
.Section-Propiedadesmexico p {
  color: black;
}
.Section-Propiedadesmexico #contenedor {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  grid-gap: 15px;
  width: 100%;
  color: black !important;
}
.Section-Propiedadesmexico #sizeimage {
  width: 79%;
}
.Section-Propiedadesmexico #sizeimage2 {
  width: 95%;
}
.Section-Propiedadesmexico #sizeicon {
  width: 90%;
}
.Section-Propiedadesmexico .padd {
  padding-bottom: 5%;
}
.Section-Propiedadesmexico #sizeContent2 {
  width: 52%;
}
.Section-Propiedadesmexico #sizeContent {
  width: 46%;
  text-align: right;
}
.Section-Propiedadesmexico .sizecolumn {
  width: 13%;
}

@media screen and (max-width: 500px) and (min-width: 100px) {
  .Section-Propiedadesmexico {
    flex-wrap: wrap;
    flex-direction: column;
  }
  .Section-Propiedadesmexico #sizeContent2 {
    width: 100%;
    padding-bottom: 30px;
    text-align: center;
  }
  .Section-Propiedadesmexico #sizeContent {
    width: 100%;
    text-align: center;
  }
  .Section-Propiedadesmexico #sizeimage {
    width: 77%;
  }
  .Section-Propiedadesmexico #sizeimage2 {
    width: 94%;
  }
  .Section-Propiedadesmexico #sizeicon {
    width: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Sections/Propiedadesmexico/Propiedadesmexico.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AACJ;AACI;EACI,uBAAA;AACR;AAEI;EACI,YAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;AADR;AAII;EACI,UAAA;AAFR;AAKI;EACI,UAAA;AAHR;AAMI;EACI,UAAA;AAJR;AAOI;EACI,kBAAA;AALR;AAQI;EACI,UAAA;AANR;AASI;EACI,UAAA;EACA,iBAAA;AAPR;AAUI;EACI,UAAA;AARR;;AAYA;EACI;IACI,eAAA;IACA,sBAAA;EATN;EAWM;IACI,WAAA;IACA,oBAAA;IACA,kBAAA;EATV;EAYM;IACI,WAAA;IACA,kBAAA;EAVV;EAaM;IACI,UAAA;EAXV;EAcM;IACI,UAAA;EAZV;EAeM;IACI,WAAA;EAbV;AACF","sourcesContent":[".Section-Propiedadesmexico {\n    width: 84%;\n    max-width: 1600px;\n    min-height: 500px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    margin: auto;\n    flex-wrap: nowrap;\n\n    hr {\n        background-color: brown;\n    }\n\n    p {\n        color: black;\n    }\n\n    #contenedor {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        align-items: center;\n        grid-gap: 15px;\n        width: 100%;\n        color: black !important;\n    }\n\n    #sizeimage {\n        width: 79%;\n    }\n\n    #sizeimage2 {\n        width: 95%;\n    }\n\n    #sizeicon {\n        width: 90%;\n    }\n\n    .padd {\n        padding-bottom: 5%;\n    }\n\n    #sizeContent2 {\n        width: 52%;\n    }\n\n    #sizeContent {\n        width: 46%;\n        text-align: right;\n    }\n\n    .sizecolumn {\n        width: 13%;\n    }\n}\n\n@media screen and (max-width: 500px) and (min-width: 100px) {\n    .Section-Propiedadesmexico {\n        flex-wrap: wrap;\n        flex-direction: column;\n\n        #sizeContent2 {\n            width: 100%;\n            padding-bottom: 30px;\n            text-align: center;\n        }\n\n        #sizeContent {\n            width: 100%;\n            text-align: center;\n        }\n\n        #sizeimage {\n            width: 77%;\n        }\n\n        #sizeimage2 {\n            width: 94%;\n        }\n\n        #sizeicon {\n            width: 50px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
